// Generated from Bravura 1.392 metadata (SIL OFL). Units: staff spaces, y up.
export interface GlyphInfo { ch: string; adv: number; sw: [number, number]; ne: [number, number] }

export const G = {
  noteheadWhole: { ch: '\uE0A2', adv: 1.688, sw: [0.0, -0.5], ne: [1.688, 0.5] },
  noteheadHalf: { ch: '\uE0A3', adv: 1.18, sw: [0.0, -0.5], ne: [1.18, 0.5] },
  noteheadBlack: { ch: '\uE0A4', adv: 1.18, sw: [0.0, -0.5], ne: [1.18, 0.5] },
  noteheadXBlack: { ch: '\uE0A9', adv: 1.16, sw: [0.0, -0.5], ne: [1.16, 0.5] },
  noteheadXHalf: { ch: '\uE0A8', adv: 1.336, sw: [0.0, -0.5], ne: [1.336, 0.5] },
  noteheadXWhole: { ch: '\uE0A7', adv: 1.508, sw: [0.0, -0.5], ne: [1.508, 0.5] },
  noteheadDiamondWhole: { ch: '\uE0D8', adv: 1.08, sw: [0.0, -0.5], ne: [1.08, 0.5] },
  noteheadDiamondHalf: { ch: '\uE0D9', adv: 1.004, sw: [0.0, -0.5], ne: [1.004, 0.5] },
  noteheadDiamondBlack: { ch: '\uE0DB', adv: 1.0, sw: [0.0, -0.5], ne: [1.0, 0.5] },
  noteheadSlashVerticalEnds: { ch: '\uE100', adv: 1.46, sw: [0.0, -1.004], ne: [1.46, 0.996] },
  noteheadSlashWhiteHalf: { ch: '\uE103', adv: 3.12, sw: [0.0, -1.0], ne: [3.12, 1.0] },
  noteheadSlashWhiteWhole: { ch: '\uE102', adv: 3.92, sw: [0.0, -1.0], ne: [3.92, 1.0] },
  noteheadCircleX: { ch: '\uE0B3', adv: 0.996, sw: [0.0, -0.5], ne: [0.996, 0.5] },
  noteheadParenthesisLeft: { ch: '\uE0F5', adv: 0.292, sw: [0.0, -0.724], ne: [0.436, 0.724] },
  noteheadParenthesisRight: { ch: '\uE0F6', adv: 0.292, sw: [-0.144, -0.724], ne: [0.292, 0.724] },
  restWhole: { ch: '\uE4E3', adv: 1.132, sw: [0.0, -0.54], ne: [1.128, 0.036] },
  restHalf: { ch: '\uE4E4', adv: 1.132, sw: [0.0, -0.008], ne: [1.128, 0.568] },
  restQuarter: { ch: '\uE4E5', adv: 1.08, sw: [0.004, -1.5], ne: [1.08, 1.492] },
  rest8th: { ch: '\uE4E6', adv: 1.0, sw: [0.0, -1.004], ne: [0.988, 0.696] },
  rest16th: { ch: '\uE4E7', adv: 1.28, sw: [0.0, -2.0], ne: [1.28, 0.716] },
  rest32nd: { ch: '\uE4E8', adv: 1.452, sw: [0.0, -2.0], ne: [1.452, 1.704] },
  rest64th: { ch: '\uE4E9', adv: 1.696, sw: [0.0, -3.012], ne: [1.692, 1.72] },
  flag8thUp: { ch: '\uE240', adv: 1.056, sw: [0.0, -3.241], ne: [1.056, 0.035] },
  flag8thDown: { ch: '\uE241', adv: 1.224, sw: [0.0, -0.058], ne: [1.224, 3.233] },
  flag16thUp: { ch: '\uE242', adv: 1.116, sw: [0.0, -3.252], ne: [1.116, 0.008] },
  flag16thDown: { ch: '\uE243', adv: 1.168, sw: [-0.0, -0.036], ne: [1.164, 3.248] },
  flag32ndUp: { ch: '\uE244', adv: 1.048, sw: [0.0, -3.248], ne: [1.044, 0.596] },
  flag32ndDown: { ch: '\uE245', adv: 1.096, sw: [0.0, -0.687], ne: [1.092, 3.248] },
  flag64thUp: { ch: '\uE246', adv: 1.048, sw: [0.0, -3.248], ne: [1.044, 1.387] },
  flag64thDown: { ch: '\uE247', adv: 1.1, sw: [0.0, -1.504], ne: [1.092, 3.248] },
  accidentalFlat: { ch: '\uE260', adv: 0.904, sw: [0.0, -0.7], ne: [0.904, 1.756] },
  accidentalNatural: { ch: '\uE261', adv: 0.672, sw: [0.0, -1.34], ne: [0.672, 1.364] },
  accidentalSharp: { ch: '\uE262', adv: 0.996, sw: [0.0, -1.392], ne: [0.996, 1.4] },
  accidentalDoubleSharp: { ch: '\uE263', adv: 1.0, sw: [0.0, -0.5], ne: [0.988, 0.508] },
  accidentalDoubleFlat: { ch: '\uE264', adv: 1.652, sw: [0.0, -0.7], ne: [1.644, 1.748] },
  accidentalParensLeft: { ch: '\uE26A', adv: 0.564, sw: [0.0, -0.992], ne: [0.564, 0.988] },
  accidentalParensRight: { ch: '\uE26B', adv: 0.564, sw: [0.0, -0.992], ne: [0.564, 0.988] },
  augmentationDot: { ch: '\uE1E7', adv: 0.4, sw: [0.0, -0.2], ne: [0.4, 0.2] },
  gClef: { ch: '\uE050', adv: 2.684, sw: [0.0, -2.632], ne: [2.684, 4.392] },
  gClef8vb: { ch: '\uE052', adv: 2.656, sw: [0.0, -3.512], ne: [2.684, 4.392] },
  fClef: { ch: '\uE062', adv: 2.736, sw: [-0.02, -2.54], ne: [2.736, 1.048] },
  cClef: { ch: '\uE05C', adv: 2.796, sw: [0.0, -2.024], ne: [2.796, 2.024] },
  unpitchedPercussionClef1: { ch: '\uE069', adv: 1.528, sw: [0.0, -1.0], ne: [1.528, 1.0] },
  timeSig0: { ch: '\uE080', adv: 1.88, sw: [0.08, -1.0], ne: [1.8, 1.004] },
  timeSig1: { ch: '\uE081', adv: 1.336, sw: [0.08, -1.0], ne: [1.256, 1.004] },
  timeSig2: { ch: '\uE082', adv: 1.784, sw: [0.08, -1.028], ne: [1.704, 1.016] },
  timeSig3: { ch: '\uE083', adv: 1.684, sw: [0.08, -1.004], ne: [1.604, 0.996] },
  timeSig4: { ch: '\uE084', adv: 1.88, sw: [0.08, -1.0], ne: [1.8, 1.004] },
  timeSig5: { ch: '\uE085', adv: 1.612, sw: [0.08, -1.004], ne: [1.532, 0.984] },
  timeSig6: { ch: '\uE086', adv: 1.736, sw: [0.08, -0.996], ne: [1.656, 1.004] },
  timeSig7: { ch: '\uE087', adv: 1.764, sw: [0.08, -1.0], ne: [1.684, 0.996] },
  timeSig8: { ch: '\uE088', adv: 1.744, sw: [0.08, -1.036], ne: [1.664, 1.036] },
  timeSig9: { ch: '\uE089', adv: 1.736, sw: [0.08, -0.996], ne: [1.656, 1.004] },
  timeSigCommon: { ch: '\uE08A', adv: 1.696, sw: [0.02, -0.996], ne: [1.696, 1.004] },
  timeSigCutCommon: { ch: '\uE08B', adv: 1.668, sw: [0.0, -1.436], ne: [1.672, 1.444] },
  dynamicPiano: { ch: '\uE520', adv: 1.46, sw: [-0.356, -0.568], ne: [1.464, 1.096] },
  dynamicMezzo: { ch: '\uE521', adv: 1.748, sw: [-0.08, -0.04], ne: [1.784, 1.096] },
  dynamicForte: { ch: '\uE522', adv: 1.456, sw: [-0.564, -0.608], ne: [1.456, 1.776] },
  dynamicPPP: { ch: '\uE52A', adv: 4.288, sw: [-0.368, -0.568], ne: [4.292, 1.096] },
  dynamicPP: { ch: '\uE52B', adv: 2.908, sw: [-0.328, -0.568], ne: [2.912, 1.096] },
  dynamicMP: { ch: '\uE52C', adv: 3.304, sw: [-0.08, -0.568], ne: [3.3, 1.096] },
  dynamicMF: { ch: '\uE52D', adv: 3.188, sw: [-0.08, -0.66], ne: [3.272, 1.724] },
  dynamicFF: { ch: '\uE52F', adv: 2.436, sw: [-0.54, -0.608], ne: [2.44, 1.776] },
  dynamicFFF: { ch: '\uE530', adv: 3.324, sw: [-0.62, -0.608], ne: [3.32, 1.776] },
  dynamicFortePiano: { ch: '\uE534', adv: 2.476, sw: [-0.564, -0.608], ne: [2.476, 1.776] },
  dynamicForzando: { ch: '\uE535', adv: 1.988, sw: [-0.564, -0.608], ne: [1.988, 1.776] },
  dynamicSforzando1: { ch: '\uE536', adv: 2.416, sw: [0.0, -0.608], ne: [2.416, 1.776] },
  dynamicSforzato: { ch: '\uE539', adv: 2.928, sw: [0.0, -0.608], ne: [2.932, 1.776] },
  dynamicSforzatoFF: { ch: '\uE53B', adv: 3.856, sw: [0.0, -0.608], ne: [3.856, 1.776] },
  articAccentAbove: { ch: '\uE4A0', adv: 1.356, sw: [0.0, 0.004], ne: [1.356, 0.98] },
  articAccentBelow: { ch: '\uE4A1', adv: 1.356, sw: [0.0, -0.976], ne: [1.356, 0.0] },
  articStaccatoAbove: { ch: '\uE4A2', adv: 0.336, sw: [0.0, 0.0], ne: [0.336, 0.336] },
  articStaccatoBelow: { ch: '\uE4A3', adv: 0.336, sw: [0.0, -0.336], ne: [0.336, 0.0] },
  articTenutoAbove: { ch: '\uE4A4', adv: 1.352, sw: [-0.004, 0.0], ne: [1.352, 0.192] },
  articTenutoBelow: { ch: '\uE4A5', adv: 1.352, sw: [-0.004, -0.192], ne: [1.352, 0.0] },
  articStaccatissimoAbove: { ch: '\uE4A6', adv: 0.408, sw: [0.004, -0.008], ne: [0.4, 1.172] },
  articStaccatissimoBelow: { ch: '\uE4A7', adv: 0.408, sw: [0.004, -1.18], ne: [0.4, 0.0] },
  articMarcatoAbove: { ch: '\uE4AC', adv: 0.944, sw: [-0.004, -0.004], ne: [0.94, 1.012] },
  articMarcatoBelow: { ch: '\uE4AD', adv: 0.944, sw: [-0.004, -1.016], ne: [0.94, 0.0] },
  fermataAbove: { ch: '\uE4C0', adv: 2.42, sw: [0.012, -0.012], ne: [2.42, 1.316] },
  fermataBelow: { ch: '\uE4C1', adv: 2.42, sw: [0.012, -1.328], ne: [2.42, 0.0] },
  ornamentTrill: { ch: '\uE566', adv: 2.084, sw: [0.0, -0.04], ne: [2.084, 1.56] },
  tremolo1: { ch: '\uE220', adv: 0.6, sw: [-0.6, -0.372], ne: [0.6, 0.376] },
  tremolo2: { ch: '\uE221', adv: 0.596, sw: [-0.604, -0.748], ne: [0.596, 0.748] },
  tremolo3: { ch: '\uE222', adv: 0.6, sw: [-0.6, -1.12], ne: [0.6, 1.112] },
  segno: { ch: '\uE047', adv: 2.228, sw: [0.016, -0.108], ne: [2.2, 3.036] },
  coda: { ch: '\uE048', adv: 3.816, sw: [-0.016, -0.632], ne: [3.82, 3.592] },
  repeat1Bar: { ch: '\uE500', adv: 2.132, sw: [0.0, -1.0], ne: [2.128, 1.116] },
  repeat2Bars: { ch: '\uE501', adv: 3.044, sw: [0.0, -1.0], ne: [3.048, 1.116] },
  repeatDot: { ch: '\uE044', adv: 0.4, sw: [0.0, -0.2], ne: [0.4, 0.2] },
  brassScoop: { ch: '\uE5D0', adv: 1.272, sw: [0.004, -1.492], ne: [1.28, 0.052] },
  brassPlop: { ch: '\uE5E0', adv: 1.172, sw: [0.004, -0.06], ne: [1.172, 1.488] },
  brassDoitMedium: { ch: '\uE5D5', adv: 1.96, sw: [0.0, -0.16], ne: [1.956, 1.384] },
  brassFallLipMedium: { ch: '\uE5D8', adv: 1.96, sw: [0.0, -1.4], ne: [1.956, 0.144] },
  brassMuteOpen: { ch: '\uE5E7', adv: 1.22, sw: [0.0, 0.0], ne: [1.216, 1.216] },
  brassMuteClosed: { ch: '\uE5E5', adv: 1.088, sw: [0.0, 0.0], ne: [1.088, 1.088] },
  brassMuteHalfClosed: { ch: '\uE5E6', adv: 1.22, sw: [0.004, 0.0], ne: [1.22, 1.216] },
  keyboardPedalPed: { ch: '\uE650', adv: 4.076, sw: [0.0, -0.032], ne: [4.076, 2.22] },
  keyboardPedalUp: { ch: '\uE655', adv: 1.8, sw: [0.0, 0.0], ne: [1.8, 1.8] },
  breathMarkComma: { ch: '\uE4CE', adv: 0.612, sw: [0.004, 0.008], ne: [0.608, 1.004] },
  stringsHarmonic: { ch: '\uE614', adv: 0.8, sw: [0.0, 0.0], ne: [0.8, 0.8] },
  stringsDownBow: { ch: '\uE610', adv: 1.248, sw: [0.0, 0.0], ne: [1.248, 1.272] },
  stringsUpBow: { ch: '\uE612', adv: 1.0, sw: [0.004, 0.004], ne: [0.996, 1.98] },
  tuplet0: { ch: '\uE880', adv: 1.276, sw: [-0.001, -0.032], ne: [1.273, 1.5] },
  tuplet1: { ch: '\uE881', adv: 0.984, sw: [0.04, 0.0], ne: [1.024, 1.488] },
  tuplet2: { ch: '\uE882', adv: 1.276, sw: [0.04, -0.024], ne: [1.316, 1.5] },
  tuplet3: { ch: '\uE883', adv: 1.184, sw: [0.04, -0.032], ne: [1.224, 1.5] },
  tuplet4: { ch: '\uE884', adv: 1.212, sw: [0.04, 0.0], ne: [1.252, 1.488] },
  tuplet5: { ch: '\uE885', adv: 1.268, sw: [0.04, -0.032], ne: [1.308, 1.492] },
  tuplet6: { ch: '\uE886', adv: 1.216, sw: [0.041, -0.032], ne: [1.256, 1.5] },
  tuplet7: { ch: '\uE887', adv: 1.212, sw: [0.12, -0.016], ne: [1.332, 1.488] },
  tuplet8: { ch: '\uE888', adv: 1.252, sw: [0.04, -0.032], ne: [1.292, 1.5] },
  tuplet9: { ch: '\uE889', adv: 1.216, sw: [0.04, -0.032], ne: [1.255, 1.5] },
  tupletColon: { ch: '\uE88A', adv: 0.444, sw: [0.04, 0.232], ne: [0.484, 1.072] },
  graceNoteAcciaccaturaStemUp: { ch: '\uE560', adv: 1.428, sw: [0.0, -0.332], ne: [1.428, 2.096] },
  arpeggiatoUp: { ch: '\uE634', adv: 0.912, sw: [0.004, 0.028], ne: [0.916, 6.044] },
  arpeggiatoDown: { ch: '\uE635', adv: 0.912, sw: [0.004, -0.016], ne: [0.916, 6.0] },
  wiggleArpeggiatoUp: { ch: '\uEAA9', adv: 1.02, sw: [-0.132, 0.0], ne: [1.168, 0.476] },
  wiggleTrill: { ch: '\uEAA4', adv: 0.948, sw: [-0.144, 0.392], ne: [1.08, 0.836] },
  wiggleVibrato: { ch: '\uEAB0', adv: 0.608, sw: [-0.056, 0.0], ne: [0.668, 0.476] },
  guitarVibratoStroke: { ch: '\uEAB2', adv: 0.608, sw: [-0.056, 0.0], ne: [0.668, 0.476] },
  metNoteQuarterUp: { ch: '\uECA5', adv: 1.328, sw: [0.0, -0.564], ne: [1.328, 2.752] },
  metNote8thUp: { ch: '\uECA7', adv: 2.136, sw: [0.0, -0.564], ne: [2.132, 2.784] },
  metNoteHalfUp: { ch: '\uECA3', adv: 1.364, sw: [0.0, -0.564], ne: [1.364, 2.752] },
  metAugmentationDot: { ch: '\uECB7', adv: 0.4, sw: [0.0, -0.2], ne: [0.4, 0.2] },
  ottava: { ch: '\uE510', adv: 1.544, sw: [0.0, -0.04], ne: [1.544, 1.852] },
  ottavaAlta: { ch: '\uE511', adv: 3.54, sw: [0.0, -0.04], ne: [3.54, 1.852] },
  ottavaBassaVb: { ch: '\uE51C', adv: 3.184, sw: [0.0, -0.04], ne: [3.184, 1.852] },
  quindicesima: { ch: '\uE514', adv: 2.668, sw: [0.0, -0.04], ne: [2.668, 1.844] },
  arrowheadBlackUp: { ch: '\uEB78', adv: 0.912, sw: [0.0, 0.0], ne: [0.912, 1.196] },
  arrowheadBlackDown: { ch: '\uEB7C', adv: 0.912, sw: [0.0, 0.0], ne: [0.912, 1.196] },
} satisfies Record<string, GlyphInfo>;

export type GlyphName = keyof typeof G;

export const ENGRAVING = {
  arrowShaftThickness: 0.16,
  barlineSeparation: 0.4,
  beamSpacing: 0.25,
  beamThickness: 0.5,
  bracketThickness: 0.5,
  dashedBarlineDashLength: 0.5,
  dashedBarlineGapLength: 0.25,
  dashedBarlineThickness: 0.16,
  hBarThickness: 1.0,
  hairpinThickness: 0.16,
  legerLineExtension: 0.4,
  legerLineThickness: 0.16,
  lyricLineThickness: 0.16,
  octaveLineThickness: 0.16,
  pedalLineThickness: 0.16,
  repeatBarlineDotSeparation: 0.16,
  repeatEndingLineThickness: 0.16,
  slurEndpointThickness: 0.1,
  slurMidpointThickness: 0.22,
  staffLineThickness: 0.13,
  stemThickness: 0.12,
  subBracketThickness: 0.16,
  textEnclosureThickness: 0.16,
  thickBarlineThickness: 0.5,
  thinBarlineThickness: 0.16,
  tieEndpointThickness: 0.1,
  tieMidpointThickness: 0.22,
  tupletBracketThickness: 0.16
} as const;
